export const sizes = {
  mediumAdPictureLargeHeight: 400,
  mediumAdPictureLargeHeightArredo: 820,
  mediumAdPictureLargeWidth: 720,
  mediumAdPictureSmallHeight: 200,
  mediumAdPictureSmallHeightArredo: 410,
  mediumAdPictureSmallWidth: 360,

  panoramaTwoThirdsPictureHeight: 458,
  panoramaTwoThirdsPictureWidth: 677,

  panoramaImageAdWidth: 1114,
  panoramaImageAdHeight: 458,

  leaderboardImageAdWidth: 1114,
  leaderboardImageAdHeight: 100,
  leaderboardAdRetinaWidth: 2228,
  leaderboardAdRetinaHeight: 200,

  leaderboardLargeAdWidth: 1114,
  leaderboardLargeAdHeight: 200,
  leaderboardLargeAdRetinaWidth: 2228,
  leaderboardLargeAdRetinaHeight: 400,

  sitewideImageAdWidth: 1114,
  sitewideImageAdHeight: 458,

  smallImageOneThirdAdLargeWidth: 720,
  smallImageOneThirdAdLargeHeight: 428,
  smallImageOneThirdAdSmallWidth: 360,
  smallImageOneThirdAdSmallHeight: 214,

  smallImageOneForthAdLargeWidth: 720,
  smallImageOneForthAdLargeHeight: 579,
  smallImageOneForthAdSmallWidth: 266,
  smallImageOneForthAdSmallHeight: 214,

  mediumImageTwoThirdsAdWidth: 1472,
  mediumImageTwoThirdsAdHeight: 820,

  redPanoramaWidth: 1500,
  redPanoramaHeight: 470,
  redPanoramaWidthMobile: 188,
  redPanoramaHeightMobile: 175
};
